import Filter from "../components/MamContent/MamFilterComponent/Filter";
import {Filters} from "./filterTypes";
import {Competition} from "./competitionTypes";

export interface eventMam {
    id: string;
    name: string;
    description: string;
    data_sources:{
        id: string;
    }[],
    type: string;
    home_team: string;
    away_team: string;
    season: string;
    championship: string;
    home_line_up: string;
    away_line_up: string;
    children:{
        name: string;
        data: clipMam;
    }
}

export interface clipMam {
    competition: string;
    match: string;
    match_date: string;
    game_time: string;
    key_moment_type: string;
    player: string;
    match_day: string;
    videoContentProduced: number;
    title: string;
}

export interface MatchDayFootball {
    name: string;
    children: {
        name: string;
        data: eventMam[];
    };
}

export interface CompetitionFootball {
    name: string;
    children: {
        name: string;
        data: MatchDayFootball[];
    };
}

export interface HierarchyFootball {
    name: string;
    data: CompetitionFootball[];
}



export interface MamSummary {
    competition: string;
    matchDay: string[];
    match: string[];
    groupClip: string[];
    entityName: string;
}

interface pageState{
    number: number;
    size: number;
}

export type MamSummaryPageState = {
    [K in keyof MamSummary]: Record<string, pageState>;
}

// Singola Clip Element
export interface ClipElement {
    id: string;
    title: string;
    duration: number;
    thumbnail: string;
    metadata: Record<string, any>; // Se ci sono altri campi dinamici
}

//Clip
export interface Clip{
    id: string,
    competition: string,
    match: string,
    match_date: string,
    period: string,
    game_time: string,
    key_moment_type: string,
    player: string,
    matchday: string,
    videoContentProduced: number,
    event_id: string,
    thumbnail: string,
    url: string,
    editorClip?: any
}

// Gruppo di Clip
export interface ClipGroup{
    id: string,
    competition: string,
    match: string,
    match_date: string,
    period: string,
    game_time: string,
    key_moment_type: string,
    player: string,
    matchday: string,
    videoContentProduced: number,
    event_id: string,
    thumbnail: string,
    url: string,
    editorClip?: any
    editing?: boolean
}

// Giornata di una competizione
export interface MatchDays {
    matchday: number;
    start?: Date;
    end?: Date;
    roundType?: string;
    competition?: Competition;
    competitionId?: string
    id: string;
    open?: boolean
}



// Struttura finale: array di Competitions
export type MamData = {
    competitions: Competition[];  // Elenco delle competizioni
    matchDay: MatchDays[];
    matchDayEvents: any[];
    clipGroups: any[];
    clip: any[];
};

export interface SearchOptions{
    jobFilterValues?: string,
    matchFilterValues?: string,
}

export enum AggregationTypes {
    ManOfTheMatch = 'man of the match',
    BestOfTheDay = 'best of the day',
    GoalParade = 'goal parade',
    BestOfTheSeason = 'best of the season',
    BestActionOfTheDay = 'best action of the day',
}

type clipContentType = Extract<VideoContentTypes, 'highlight' | 'socialClip'>;
export type VideoContentTypes = 'clip' | 'highlight' | 'socialClip';


export interface MamClipPlatform {
    id: string;
    title: string;
    key_moment_type?: string;
    player?: string;
    team?: string;
    period?: string;
    game_time?: string;
    rating?: number;
    duration: string;
    descriptions: Array<{
        id: string;
        description: string;
        language: string;
        style: string;
    } | null>;
    job_id: string;
    event_id: string;
    frame_rate: number;
    stream_time_start?: number;
    stream_time_end?: number;
    attributes?: Record<string, any>; // or `{}` if the attributes object is guaranteed to be empty
    //Aggiunti
    extraction_schedule: string;
    match: string;
    competition: string;
    competition_id: string;
    type: string;
    thumbnail: string | null;
    match_date?: string;
    matchday: string;
    social_clip_url: string;
    aspect_ratio: string;
    edit_state_id?: string;
    original_clip_url: string;
    cloudfront_thumbnail: string;
    groupId?: string;
    tags?: string[];
    videoContentType:clipContentType,
    generate_at?: string;
    highlight_type?: string
    selected?: boolean
}



